import { A4uMore as IconComponent } from '@adobe/react-spectrum-workflow/dist/More.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function More(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}